import { call, put, getContext, takeLatest } from 'redux-saga/effects';
import { GET_INVOICE_NOTIF } from '../../redux/reducers/constants';
import { setInvoiceNotif } from '../../redux/actions';
import { errorHandler } from '../common/errorHandler';

function* getInvoiceNotifications(action) {
    try {
        const { operationId } = action;
        const billingGateway = yield getContext('billingNewGateway');

        const invoices = yield call(billingGateway.getInvoices, operationId);

        const draftInvoiceIds = invoices
            .filter((invoice) => invoice.status === 'DRAFT')
            .map((invoice) => invoice.id);

        if (draftInvoiceIds.length > 0) {
            yield put(setInvoiceNotif(draftInvoiceIds));
        }
    } catch (error) {
        yield errorHandler(error);
    }
}

export function* getInvoiceNotificationsSaga() {
    yield takeLatest(GET_INVOICE_NOTIF, getInvoiceNotifications);
}
const notificationsSaga = [getInvoiceNotificationsSaga];

export default notificationsSaga;
